import React, { createContext, useContext, useState, useCallback } from "react";
import SnackbarAlert from "../components/SnackbarAlert"; // adjust path as needed

const SnackbarAlertContext = createContext();

export const SnackbarAlertProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState(null);

  const trigger = useCallback((message, severity = "info", overrides = {}) => {
    setSnackbar({
      open: true,
      message,
      severity,
      ...overrides,
    });
  }, []);

  const success = (msg, overrides = {}) => trigger(msg, "success", overrides);
  const error = (msg, overrides = {}) => trigger(msg, "error", overrides);
  const warning = (msg, overrides = {}) => trigger(msg, "warning", overrides);
  const info = (msg, overrides = {}) => trigger(msg, "info", overrides);

  const close = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarAlertContext.Provider value={{ success, error, warning, info }}>
      {children}
      {snackbar?.open && (
        <SnackbarAlert
          open={snackbar.open}
          onClose={close}
          message={snackbar.message}
          severity={snackbar.severity}
          autoHideDuration={snackbar.autoHideDuration}
          bgColor={snackbar.bgColor}
        />
      )}
    </SnackbarAlertContext.Provider>
  );
};

export const useSnackbarAlert = () => useContext(SnackbarAlertContext);
